import app from 'flarum/forum/app';
import addLinks from './addLinks';
import addProfileFields from './addProfileFields';
import addComposerFields from './addComposerFields';
import addFormOnDiscussionPost from './addFormOnDiscussionPost';
import addRoutes from './addRoutes';
import addSignUpFields from './addSignUpFields';
import addUnifiedComposer from './addUnifiedComposer';
import patchStore from './patchStore';
import extendModels from './extendModels';
import extendRoutes from './extendRoutes';

export * from './components';
export * from './fields';
export * from './pages';

export const extend = [
    ...extendModels,
    ...extendRoutes,
];

app.initializers.add('kilowhat-formulaire', () => {
    addLinks();
    addProfileFields();
    addComposerFields();
    addFormOnDiscussionPost();
    addRoutes();
    addSignUpFields();
    patchStore();
});

// The priority isn't super important, as long as it's below zero
// This is to make sure that it works even if Flarum's optional extension dependencies are not resolving quite right
app.initializers.add('kilowhat-formulaire-delayed', () => {
    addUnifiedComposer();
}, -100);
